import React from "react";
import Image from "next/image";

const BridgeUni: React.FC = () => {
  return (
    <>
      <div className="bg-white w-full md:py-[50px] py-8 relative md:bg-bottom bg-center md:bg-[#061A2F] bg-repeat bg-cover bg-[length:100% 100%] relative">
        <Image
          src="/cpa/bg_logo.png"
          alt="Special Offer"
          className="md:block hidden mx-auto absolute -bottom-6 left-0"
          width={503}
          height={463}
          priority
        />
        <div className="lg:container mx-auto h-full 2xl:px-0 xl:px-12 lg:px-6 px_5 md:mb-6 relative lg:block hidden">
          <div className="flex flex-row gap-2 justify-center md:mt-6">
            <div className="rounded-md">
              <div className="w-[575px]">
                <Image
                  src="/cpa/bridge-course/uniJain.svg"
                  alt="jain uni"
                  className=""
                  width={575}
                  height={330}
                  priority
                />
              </div>
            </div>

            <div className="px-4 md:leading-[1.2] items-start">
              <div className="text-start">
                <h2 className="text-2xl lg:text-[28px] md:text-[28px] mb-3 lg:leading-[1.3]  leading-[1.8rem] text-[#FFF] font-semibold text-center inline-block mx-auto px-[4px] md:mb-[20px]">
                  <span className="md:pb-0 inline-block border-[#ca7216] md:border-b-[4px] border-b-2">
                    About Jain University
                  </span>
                </h2>
              </div>
              <p className="text-white font-medium text-[20px] md:leading-[1.3] mr-6">
                For over 30 years, Jain University has been at the forefront of
                delivering quality education, combining academic excellence with
                real-world relevance. Accredited and globally recognized, Jain
                University offers a CPA-integrated master’s programs that equips
                students with comprehensive accounting knowledge and
                international credentials. With flexible learning options, this
                program prepares future-ready professionals for global
                opportunities in finance and accounting.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default BridgeUni;
